// extracted by mini-css-extract-plugin
export default {"wrapper":"ListTooltip_wrapper__xLMw9","tooltipBox":"ListTooltip_tooltipBox__F-fMY"};